module.exports = __webpack_public_path__ + "media/images/hromadne-44ead881f2cdcb730bad97b7ba61b114.png";